import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import DataTableComponent from "../../../../../Util/DataTable/DataTable";
import RateCard from "../../../../../Util/RateCard/RateCard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../Events/Events.css";
import "../Events/Event.css";
import { config } from "../../../../../config";
import { EVENT_STATUS, formatNumberToCurrency, LEAD_STATUS, LEAGUE_STATUS } from "../../../../../Util/helper";
import axiosApi from "../../../../../core/interceptor/interceptor";
import * as moment from 'moment';
import { motion } from 'framer-motion';
import { pageTransitions, transitionDuration } from '../../../../../Util/PageTransitions';

function InvoiceListing(props) {
  const LEADTYPE = {
    lead: 'Lead',
    event: 'Event'
  };
  const columns = [
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Event Name</div>,
      selector: () => 'title',
      className: 'left-align',
      minWidth: '130px !important',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.event_id ? `${row.event?.title}` : row.lead_id ? row.lead?.title : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Type</div>,
      selector: () => 'type',
      minWidth: '160px !important',
      sortable: 'true',
      style: {
        padding: '0',
        whiteSpace: 'pre-wrap !important'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start !important', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.type ? LEADTYPE[row.type] : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Created on</div>,
      selector: () => 'invoice_date',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.invoice_date ? moment(row.invoice_date).format('MM/DD/YYYY') : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Payment Status</div>,
      selector: () => 'status',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.status ? LEAGUE_STATUS[row.status] : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Due date</div>,
      selector: () => 'due_date',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.due_date ? moment(row.due_date).format('MM/DD/YYYY') : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'center', wordBreak: 'break-word' }}>View</div>,
      selector: () => 'client_name',
      minWidth: '136px !important',
      center: true,
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}><div className='btn-group'>
        { 
          row.file_name &&
          <button className='btn with-icon' onClick={() => viewInvoice(row.file_url)}>View</button>
        }
    </div></div>)
    },
  ];

  const history = useHistory();
  const [totalPage, setTotalPage] = useState(0);
  const [invoices, setInvoices] = useState([]);
  const [queryparam, setQueryparam] = useState({
    search: '',
    direction: 'desc',
    sort_column: '',
    page: 1,
    limit: 50,
  });
  const [overview, setOverview] = useState({
    totalAmount: 0,
    pendingAmount: 0,
    completedAmount: 0,
    refunded: 0,
  });

  const handleChange = (e) => {
    let stateFunc = null;
    if (e.type === 'sort') {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
        'direction': e.target.direction,
      })
    } else {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: String(e.target.value).trim(),
      })
    }
    setQueryparam(stateFunc);
  }

  const viewInvoice = (file_url) => {
    window.open(`${file_url}`);
  }

  const getInvoices = (params) => {
    axiosApi.get(`${config.apiUrl}/invoice/all`, { params })
    .then((res) => {
      if (res && res.data && res.data.data && res.data.data.rows)
      setInvoices(res.data.data.rows);
    })
  }

  const getOverview = () => {
    axiosApi.get(`${config.apiUrl}/invoice/overview`)
    .then((res) => {
      if (res && res.data && res.data.data) {
        const data = res.data.data;
        setOverview((prev) => ({
          ...prev,
          totalAmount: data[0].totalAmount,
          pendingAmount: data[0].pendingAmount,
          completedAmount: data[0].completedAmount,
          refunded: data[0].refunded,
        }))
      }
    })
  }

  const handleSearch = (e) => {
    e.preventDefault();
    setQueryparam(() => ({
      ...queryparam,
      'page': 1,
      'direction': '',
      'sort_column': '',
    }))
    getInvoices(queryparam)
  }

  useEffect(() => {
    getOverview();
  }, [])

  useEffect(() => {
    getInvoices(queryparam);
  }, [queryparam.page, queryparam.limit, queryparam.direction, queryparam.sort_column])

  return (
    <>
      <motion.div className='outer-wrapper cs-leads-page' initial={pageTransitions.initial} animate={pageTransitions.in} exit={pageTransitions.out} transition={{ duration: transitionDuration }}>
        <div className="content-wrapper leagues-wrapper">
          <div className="heading-wrapper">
            <h2 className="heading">{'Invoices'}</h2>
          </div>
          <div className="tab-view-btns">
            
          </div>
          <div className="user-wrapper">
              <div className="header-blk">
                <h2>Overview</h2>
              </div>
              <div className="cards-wrapper">
                <div className="cards-blk">
                  <RateCard text='Total Invoice Amount' value={formatNumberToCurrency(overview.totalAmount) || 0} />
                  <RateCard text='Pending Payment Amount' value={formatNumberToCurrency(overview.pendingAmount) || 0} />
                  <RateCard text='Completed Payment Amount' value={formatNumberToCurrency(overview.completedAmount) || 0} />
                  <RateCard text='Refunded Amount' value={formatNumberToCurrency(overview.refunded) || 0} />
                </div>
              </div>
              <div className="search-blk search-blk-invoice with-add-btn">
                <h2>Search</h2>
                <div className="lead-form-add-btn">
                  <form onSubmit={handleSearch}>
                    <div className="input-field">
                      <label htmlFor="first_name">Title</label>
                      <input type="text" id="title" name="search" onChange={handleChange} />
                    </div>
                    <button type='submit'>Search</button>
                  </form>
                </div>
              </div>
              <div className="table-wrapper">
                <div className="heading-blk">
                  <div className="left">
                    <h2>Results</h2>
                    <p>Select an invoice to view details.</p>
                  </div>
                </div>
                <div className="dataTable">
                  <DataTableComponent key="table-admin-users"
                    // loading={loader}
                    type={'invoices'}
                    disableRowClicked={true}
                    data={invoices}
                    columns={columns}
                    onFilterChange={handleChange}
                    totalPage={totalPage}
                  // limit={userDetail.limit}
                  // refresh={() => getUsers()} 
                  />
                </div>
              </div>
            </div>
        </div>
      </motion.div>
    </>
  );
}

export default withRouter(InvoiceListing);
